import React, {Fragment} from 'react'
import UserIcon from '../assets/user.svg'
import Lock from '../assets/lock-green.svg'

let friend = '';
if (typeof window !== 'undefined') {
    friend = window.location.pathname.startsWith('/invite');    
} 

export const menuItems = [
    {title: 'Logga in på Mina Sidor', subTitle: 'Om du har ett konto och vill hantera din prenumeration.', link: '/login', icon: <UserIcon />, linkType: 'internal', target:"_blank"},
    {title: 'Logga in F - ÅK 3', subTitle: '', link: '/webinfo', icon: <Lock />, linkType: 'external', target:"_self"},
    {title: 'Logga in ÅK 4 - ÅK 9', subTitle: '', link: '/appguide', icon: <Lock />, linkType: 'internal', target:"_self"},
];

export const menuItemsKlarna = [
    {title: 'Logga in på Mina Sidor', subTitle: 'Om du har ett konto och vill hantera din prenumeration.', link: '/sv/login', icon: <UserIcon />, linkType: 'internal', target:"_blank"},
    {title: 'Logga in F - ÅK 3', subTitle: '', link: 'https://login.hejalbert.se/auth/login', icon: <Lock />, linkType: 'external', target:"_blank"},
    {title: 'Logga in ÅK 4 - ÅK 9', subTitle: '', link: '/sv/appguide', icon: <Lock />, linkType: 'internal', target:"_self"},
];

const meta = [
    {
    name: "description",
    content: "Albert är Barnens Digitala Mattelärare. Med tusentals övningar och animerade videos hjälper han dig att förstå matematiken du behöver kunna för just din årskurs.",
    },
    {
    name: "keywords",
    content: "Albert, Math, Mattelärare, Digitala Mattelärare, matematiken",
    },
    
]
// meta.push({
//     name: "og:title",
//     content: friend 
//         ? "Varsågod, din vän har bjudit in dig till gratis läxhjälp!" // Friend invite via Facebook
//         : "Albert", // Original share via Facebook
// })
// meta.push({
//     name: "og:description",
//     content: friend 
//         ? "Jag bjuder dig på 30 dagar gratis användning av Albert - Barnens digitala mattelärare! Klicka på länken för att ta emot gåvan." // Friend invite via Facebook
//         : "Albert är Barnens Digitala Mattelärare. Med tusentals övningar och animerade videos hjälper han dig att förstå matematiken du behöver kunna för just din årskurs.", // Original invite via Facebook
// })

export const metaTags = meta

export const content = {
        faq: [
            {
                heading: 'Kom Igång',
                content: [
                    {
                        title: 'Hur skapar jag ett konto?',
                        content: [
                            "Ett konto skapar du på vår hemsida. För Albert, för barn mellan 10 och 16 år, kan du även skapa ett konto genom att ladda ner appen via App Store eller Google Play. Om du laddar ner appen direkt klickar du på ”Registrera dig” och loggar sedan in.",
                        ]
                    },
                    {
                        title: 'Vad behöver jag för att skapa ett konto?',
                        content: [
                            "En smartphone eller surfplatta med internetuppkoppling är allt som behövs. Och så givetvis en e-postadress. Logga sedan in med inloggningsuppgifterna som du får vid registrering och kom igång direkt."
                        ]
                    }
                ]
            },
            {
                heading: 'Läxhjälp',
                content: [
                    // {
                    //     title: 'Jag har kört fast i en uppgift i min bok, kan Albert hjälpa mig med den?',
                    //     content: [
                    //         "Ja, så länge du har valt en av de böckerna som Albert kan. Just nu har Albert lärt sig Matematikboken X, Y och Z samt Matte Direkt 7, 8 och 9. E Har Albert inte lärt sig just den boken du har i skolan kommer han istället automatiskt rekommendera dig uppgifter som är väldigt lika dom du har i din bok. Vi vet, Albert är grym!"
                    //     ]
                    // },
                    // {
                    //     title: 'Vad gör jag om Albert inte har just min bok som alternativ just nu?',
                    //     content: [
                    //         "Har Albert inte lärt sig just den boken du har i skolan kommer han istället automatiskt skicka dig vidare till en motsvarande bok som han kan, och det är nästan lika bra det!",
                    //         "Du kommer att ha tillgång till ca 200 digitala lektioner och test-centret för att kunna mäta dina kunskaper. Albert kommer även kunna ge dig skräddarsydda rekommendationer på vad du behöver träna mer på och även ta fram uppgifter som du ska träna på för att bli en riktig mattemästare! Bra va?"
                    //     ]
                    // },
                    {
                        title: 'Hur många matematiklektioner finns det i Albert-appen?',
                        content: [
                            "I Albert-appen finns cirka 300 videolektioner som förklarar alla matematiska koncept du behöver kunna för din årskurs. Alberts lektioner innehåller exempel från verkliga livet vilket gör matematiken roligare och lättare att relatera till."
                        ]
                    },
                    // {
                    //     title: 'Vad är "Testa dina kunskaper"?',
                    //     content: [
                    //         "Det är en premiumfunktion i Albert som hjälper dig som elev att hela tiden hålla koll på din kunskapsnivå och hur du ligger till. Vi bjuder dock på ett test, med rättning och rekommendationer. ",
                    //         "Genom denna funktion kan du vara proaktiv innan dina prov i skolan. Denna funktion kommer öka chanserna att maxa nästa prov då du snabbt upptäcker vad du behöver träna mer på! Perfekt inför kapitelprov och de nationella proven."
                    //     ]
                    // },
                    {
                        title: 'Jag tror att Albert har gjort fel i en uppgift, vad ska jag göra?',
                        content: [
                            "Albert är programmerad på ett sätt som gör att han blir bättre och bättre ju mer han används. Du kan känna dig säker på att det inte dröjer alltför länge innan Albert hittat felet och rättat till det. Vill du att Albert rättar till felet omgående, skicka oss ett mail på <a href='mailto:support@hejalbert.se' class='faq-link'>support@hejalbert.se</a> med lite information om vilket område och uppgift det gäller, så fixar vi till det inom 48 timmar."
                        ]
                    },
                    {
                        title: 'Är Albert kopplad till läroplanen?',
                        content: [
                            "Ja, Albert är egentligen mer än kopplad till läroplanen. Han har identifierat varje uppgifts unika syfte kopplat till läroplanen och vet vad du som elev behöver kunna för att klara alla steg i lösningsgången. Vi har brutit ner varje uppgift i dess minsta beståndsdelar för att bli mer träffsäkra och kunna skräddarsy upplevelsen för just dig."
                        ]
                    },
                    {
                        title: 'Vad är det som gör Albert så speciell?',
                        content: [
                            "Albert är programmerad på ett sätt som gör att han lär sig själv för varje gång han används (det kallas för artificiell intelligens). Ju mer Albert används, desto bättre blir han. Vårt mål att att han ska bli helt perfekt och det kan vi uppnå tillsammans med dig!"
                        ]
                    },
                    {
                        title: 'Är det något mer som är unikt med Albert?',
                        content: [
                            "Det finns massor med saker! Men något vi är väldigt stolta över är att Albert över tid lär känna varje unik användare och elev. Albert kan därmed ge skräddarsydd och flexibel läxhjälp utefter dina behov. Exempelvis kommer han lära sig vilka områden du som elev är bra på och vad du behöver förbättra. Och inte nog med det, Albert tar även fram lämpliga uppgifter som du kan träna på för att vända svagheter till styrkor."
                        ]
                    }

                ]
            },
            {
                heading: 'Support',
                content: [
                    {
                        title: 'Vad ska jag göra om appen strular?',
                        content: [
                            "Tyvärr kan det hända att appen strular. Det är inget vi är stolta över, men Albert är på sätt och vis nyfödd, trots att han är så klok. Kontaktar du oss via mail på <a href='mailto:support@hejalbert.se' class='faq-link'>support@hejalbert.se</a> och förklarar hur appen strular, så hjälper vi dig givetvis!"
                        ]
                    },
                    {
                        title: 'Jag är lärare och intresserad av att tillgängliggöra Albert för mina elever på skolan. Går det?',
                        content: [
                            "Givetvis, det är bara att kontakta oss på <a href='mailto:info@hejalbert.se' class='faq-link'>info@hejalbert.se</a> så tar vi kontakt med dig inom 24 timmar och försöker tillgängliggöra Albert för dina elever så fort som möjligt."
                        ]
                    },
                    {
                        title: 'Hur snabba är ni på att svara på supportärenden?',
                        content: [
                            "Vi har satt en maxgräns på 48 timmar under helgfria vardagar. Skickar du ett mail fredag–söndag får du svar senast på måndag! Men, vi kommer göra vårt bästa för att imponera på dig med svarstiden. Vi är snabba, testa oss!"
                        ]
                    },
                    // {
                    //     title: 'Varför finns det färre övningar i Albert Jr-appen?',
                    //     content: [
                    //         "Albert Jr är vårt senaste tillskott i Albertfamiljen. Det är en appversion av vår webbaserade tjänst för barn upp till 10 år. Den håller fortfarande på att utvecklats och har därför färre övningar till en början. Nya övningar fylls på allt efter som. Du hittar tjänsten i sin helhet i den webbaserade versionen. Logga in på hejalbert.se"
                    //     ]
                    // }
                ]
            },
            {
                heading: 'Pris & Abonnemang',
                content: [
                    // {
                    //     title: 'Kostar Albert någonting?',
                    //     content: [
                    //         "Albert finns i två (2) versioner, en basversion och en premiumversion. I basversionen får du alla lektioner och 10 tillfällen per kapitel där du kan fråga Albert om hjälp att lösa en uppgift. ",
                    //         "Vill du använda Albert mer än så, eller få tillgång till specialfunktioner som ”Testa dina kunskaper” kan du enkelt uppgradera till premiumversionen. Kom ihåg: du testar alltid Premium gratis i 7 dagar. "
                    //     ]
                    // },
                    {
                        title: 'Hur mycket kostar premiumversionen av Albert?',
                        content: [
                            "Priset är inte i närheten av de flera hundra kronor per timme som det kostar med fysisk läxhjälp. Köper du appen via vår hemsida så kostar den under hundralappen i månaden! Mer exakt 99 kronor per månad. Vi vet, det är en rätt bra deal för obegränsat med läxhjälp. Väljer du att registrera dig via App Store/Google Play tillkommer deras avgifter."
                        ]
                    },
                    // {
                    //     title: 'Måste man uppgradera till hemma/premium version av Albert?',
                    //     content: [
                    //         "Nej, har din skola ett samarbete med oss får du tillgång till en basversion av Albert där huvudfunktionerna är inkluderade, om än något begränsade. Du kommer alltid att ha tillgång till denna version."
                    //     ]
                    // },
                    // {
                    //     title: 'Kan skolan bekosta Albert till sina elever?',
                    //     content: [
                    //         "Ja, Albert kommer på sikt att kunna köpas in av både skolor, elever, kommuner och föräldrar. Vårt mål är att tillgängliggöra Albert till så många elever som möjligt i Sverige. ",
                    //         "Även om vår tanke är att elever/föräldrar själva köper Albert, så tackar vi givetvis inte nej till en möjlighet att kunna hjälpa ännu fler elever.  Kontakta oss på info@hejalbert.se så berättar vi gärna mer."
                    //     ]
                    // },
                    // {
                    //     title: 'Kan jag använda Albert även om min skola inte har samarbete med Albert?',
                    //     content: [
                    //         "Ja, givetvis. Det är bara att ladda ner Albert från App Store / Play Butik och registrera ett konto! ",
                    //         "Eller nästan ännu bättre, så kan du skapa ett konto direkt här på hemsidan www.hejalbert.se. "
                    //     ]
                    // },
                    {
                        title: 'Det står att jag kan påbörja min gratisperiod, hur funkar det?',
                        content: [
                            "Oavsett var och hur du registrerar dig, kan du alltid testa Albert Premium utan att betala något. Den kostnadsfria provperioden varierar mellan 14 och 30 dagar (ibland ännu längre) beroende på vilka kampanjer som ligger aktiva."
                        ]
                    },
                    {
                        title: 'Hur avslutar jag min prenumeration på Albert?',
                        content: [
                            "Vi tycker såklart att det är supertråkigt om du bestämmer dig för att avsluta din prenumeration på Albert! Men vi hjälper dig givetvis att få till ett avslut så smidigt som möjligt.",
                            "Notera att vår support inte har någon manuell hantering när det kommer till avslut av prenumerationer. Men, det är verkligen superenkelt att göra det själv!",
                            "Om du köpt prenumerationen via hemsidan kan du enkelt avsluta den under ”Mina sidor”. Om du debiteras 99 kronor har du skapat kontot via hemsidan (Albert är dyrare om man skapar Premiumkontot inne i appen, via App store eller Google Play).",
                            "<b><br/>Så här gör du:</b>",
                            "1. Gå in på <a href='https://hejalbert.se' class='faq-link'>hejalbert.se</a>",
                            "2. Klicka på \"Logga in\"",
                            "3. Klicka på \"Logga in på Mina Sidor\"",
                            "4. Gå in på \"Prenumeration\"",
                            "5. Välj \"Avsluta Prenumeration\"",
                            "6. Klart!",
                            
                            "<b><br/>Om du uppgraderat till Premium inne i appen, via App Store eller Google Play:</b>",
                            "Om du debiteras 119 kronor i månaden drar vi slutsatsen att du uppgraderat till Premium via appen. Isåfall behöver du avsluta prenumerationen via Apple eller Googles egna infrastrukturer.",
                            "<b><br/>Har du köpt via App Store?</b>",
                            "Via följande länk kan du få detaljerad beskrivning om hur du avslutar kontot:",
                            "<a href='https://support.apple.com/sv-se/HT202039' class='faq-link'>https://support.apple.com/sv-se/HT202039</a>",
                            "<b><br/>Har du köpt via Google Play?</b>",
                            "Via följande länk kan du få detaljerad beskrivning om hur du avslutar kontot:",
                            "<a class='faq-link' href='https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform=Android&oco=1'>https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform=Android&oco=1</a>",
                        ]
                    }
                ]
            },
            {
                heading: 'Integritet',
                content: [
                    {
                        title: 'Vad ska jag göra om jag glömt mitt lösenord?',
                        content: [
                            "Om du inte minns ditt lösenord kan du återställa det här: <a href='https://hejalbert.se/forgot-password' class='faq-link'>https://hejalbert.se/forgot-password</a>"
                        ]
                    },
                    {
                        title: 'Vilka personuppgifter samlar ni in?',
                        content: [
                            "Vi samlar inte in några känsliga uppgifter alls. Det vi behöver veta är din e-postadress, för att kunna registrera ditt konto, och givetvis vilken årskurs ditt barn går i, så att Albert kan hjälpa er på bästa tänkbara sätt."
                        ]
                    },
                    {
                        title: 'Behöver jag ha målsmans godkännande?',
                        content: [
                            "Ja, om du är minderårig vill vi att du får tillåtelse av din målsman att använda Albert. Genom att du godkänner användarvillkoren förutsätter vi att du frågat och fått godkänt att använda Albert.                            "
                        ]
                    },
                    {
                        title: 'Kan jag få utdrag på mina sparade personuppgifter?',
                        content: [
                            "Ja, givetvis kan du få det. Maila <a href='mailto:support@hejalbert.se' class='faq-link'>support@hejalbert.se</a> så gör vi ett utdrag och skickar till dig."
                        ]
                    },
                    {
                        title: 'Kan jag få mina personuppgifter raderade?',
                        content: [
                            "Ja, givetvis kan du få det. Maila <a href='mailto:support@hejalbert.se' class='faq-link'>support@hejalbert.se</a> så raderar vi alla dina personuppgifter. OBS! Notera att det innebär att ditt konto avslutas."
                        ]
                    },
                    {
                        title: 'Vart vänder jag mig om jag har frågor om appen eller om innehållet i appen?',
                        content: [
                            "Du är välkommen att kontakta oss på <a href='mailto:support@hejalbert.se' class='faq-link'>support@hejalbert.se</a>."
                        ]
                    }
                ]
            }
        ]
    }

export const subscriptionDatalayerValues = () => {
    return {
        common: {
            junior: {
                type: 'junior',
                value: 400
            },
            senior: {
                type: 'senior',
                value: 800
            }
        },
        aftonbladet: {
            junior: {
                type: 'junior',
                value: 400
            },
            senior: {
                type: 'senior',
                value: 800
            }
        },
        sixMonthLock: {
            junior: {
                type: '6 month junior',
                value: 520
            },
            senior: {
                type: '6 month senior',
                value: 1040
            }
        },
        twelveMonthLock: {
            junior: {
                type: '12 month junior',
                value: 600
            },
            senior: {
                type: '12 month senior',
                value: 1300
            }
        },
    }
}